import Box, { type BoxProps } from '@mui/material/Box';

import { type GlassTint, glassSurfaceSx } from '@/theme';

export type GlassPanelProps = BoxProps & {
  /** `dark` on a band that is dark in both colour schemes; see theme/glass.ts. */
  tint?: GlassTint;
};

/**
 * A frosted surface, and nothing else. It holds no layout and no padding, so
 * the panel it becomes is decided by whoever renders it.
 */
export function GlassPanel({ tint = 'theme', sx, ...rest }: GlassPanelProps) {
  return <Box {...rest} sx={[...glassSurfaceSx(tint), ...(Array.isArray(sx) ? sx : [sx])]} />;
}
